import type { DataBlock } from 'de-zurich-ui-library'
import type { DataBlockArrayCreator } from '@/utils/shur/SHURDataBlockCreator'
import { type Contract } from 'shur-api'
import { t } from '@/i18n'

/**
 * Creator for TRANSPORT/UNKNOWN productSubType
 * Returns a static information card indicating that contract details are not available
 */
export class SHURDataTransportUnknownCreator implements DataBlockArrayCreator {
  createDatablockArray(contract: Contract): DataBlock[] {
    return [createTransportUnknownDataBlock()]
  }
}

function createTransportUnknownDataBlock(): DataBlock {
  return <DataBlock>{
    title: {
      label:
        t('shurDetails.sections.TRANSPORT_UNKNOWN.title') ??
        'Informationen zu Ihrem Vertrag'
    },
    data: [
      {
        label: '',
        value:
          t('shurDetails.sections.TRANSPORT_UNKNOWN.content') ??
          'Die Vertragsdetails zu dieser Versicherung sind aktuell nicht in Meine Zurich verfügbar. Weitere Informationen entnehmen Sie bitte Ihren Unterlagen.'
      }
    ]
  }
}
